import { useNavigate } from "react-router-dom";
import { Card, CardHeader, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import {
  Accordion,
  AccordionItem,
  AccordionTrigger,
  AccordionContent,
} from "@/components/ui/accordion";
import { ArrowRight, Scale, Shield, CheckCircle2, FileSearch, Lock, Gift } from "lucide-react";
import { useLanguage } from "../contexts/LanguageContext";
import { useCookieConsent } from "../contexts/useCookieConsent";
import { LanguageSwitch } from "@/components/LanguageSwitch";
import Logo from "@/components/Logo";

const KPIBoard = () => {
  const { t } = useLanguage();
  return (
    <div className="w-full rounded-3xl shadow-2xl shadow-black/20 backdrop-blur-xl p-6 md:p-10 space-y-8" style={{ backgroundColor: '#FFFFFF', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div>
          <h2 className="text-2xl md:text-3xl font-semibold tracking-tight" style={{ color: '#1B211A' }}>
            {t('landing.stats.title')}
          </h2>
        </div>
      </div>

      {/* KPI Grid */}
      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6">
        {/* KPI 1 */}
        <Card className="rounded-2xl transition-colors" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <CardHeader className="pb-2 space-y-0">
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-semibold" style={{ color: '#1B211A' }}>🛑 {t('landing.stats.value1')} </span>
            </div>
            <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
              {t('landing.stats.borrowers.description')}
            </p>
          </CardContent>
        </Card>

        {/* KPI 2 */}
        <Card className="rounded-2xl transition-colors" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <CardHeader className="pb-2 space-y-0">
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-semibold" style={{ color: '#1B211A' }}>💯 {t('landing.stats.value2')} </span>
            </div>
            <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
              {t('landing.stats.cases.description')}
            </p>
          </CardContent>
        </Card>

        {/* KPI 3 */}
        <Card className="rounded-2xl transition-colors" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <CardHeader className="pb-2 space-y-0">
          </CardHeader>
          <CardContent className="space-y-3">
            <div className="flex items-baseline gap-2">
              <span className="text-2xl font-semibold" style={{ color: '#1B211A' }}>📅 {t('landing.stats.value3')} </span>         
            </div>
            <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
              {t('landing.stats.period.description')}
            </p>
          </CardContent>
        </Card>

    
      </div>

      {/* Chart & explanation
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 items-stretch">
        <Card className="lg:col-span-2 rounded-2xl overflow-hidden" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <CardHeader className="flex flex-row items-center justify-between pb-2">
            <div>
              <CardTitle className="text-sm font-medium" style={{ color: '#1B211A' }}>
                TBD in the future when we have something what we analysed vs success
              </CardTitle>
              <p className="text-xs mt-1" style={{ color: 'rgb(100, 130, 160)' }}>
                ?????
              </p>
            </div>
            <Badge className="rounded-full px-3 py-1 text-[11px]" style={{ backgroundColor: 'rgba(169, 201, 232, 0.2)', color: '#1B211A', border: '1px solid rgba(169, 201, 232, 0.4)' }}>
              Demo data
            </Badge>
          </CardHeader>
          <CardContent className="h-64 pt-4">
            <ResponsiveContainer width="100%" height="100%">
              <LineChart data={inquiriesData} margin={{ top: 10, right: 10, left: -20, bottom: 0 }}>
                <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.2} stroke="rgb(100, 130, 160)" />
                <XAxis dataKey="year" stroke="rgb(100, 130, 160)" fontSize={12} tickLine={false} axisLine={false} />
                <YAxis stroke="rgb(100, 130, 160)" fontSize={11} tickLine={false} axisLine={false} />
                <Tooltip
                  contentStyle={{
                    backgroundColor: "#FFFFFF",
                    border: "1px solid rgba(169, 201, 232, 0.4)",
                    borderRadius: "0.75rem",
                    fontSize: 12,
                  }}
                  labelStyle={{ color: "#1B211A" }}
                />
                <Line
                  type="monotone"
                  dataKey="cases"
                  stroke="rgb(169, 201, 232)"
                  strokeWidth={2.2}
                  dot={{ r: 3, fill: "rgb(169, 201, 232)" }}
                  activeDot={{ r: 5, fill: "rgb(169, 201, 232)" }}
                />
              </LineChart>
            </ResponsiveContainer>
          </CardContent>
        </Card>

        <Card className="rounded-2xl flex flex-col justify-between" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <CardContent className="pt-6 flex flex-col gap-4">
            <div>
        
            </div>
            <div className="space-y-2 text-xs" style={{ color: '#1B211A' }}>
                  <a>Users with positive feedback</a>             
            </div>
            <div className="mt-2 p-3 rounded-xl text-[11px] leading-relaxed" style={{ backgroundColor: 'rgba(169, 201, 232, 0.1)', border: '1px solid rgba(169, 201, 232, 0.3)', color: 'rgb(100, 130, 160)' }}>
        
            </div>
          </CardContent>
        </Card>
      </div> */}
    </div>
  );
};

const CreditRefundLandingPage = () => {
  const { t, language } = useLanguage();
  const { openSettings: openCookieSettings } = useCookieConsent();
  const navigate = useNavigate();

  const faqs = [
    { q: t('faq.q1'), a: t('faq.a1') },
    { q: t('faq.q2'), a: t('faq.a2') },
    { q: t('faq.q3'), a: t('faq.a3') },
    { q: t('faq.q4'), a: t('faq.a4') }
  ];

  return (
    <div className="min-h-screen flex flex-col" style={{ backgroundColor: '#FFFFFF', color: '#1B211A' }}>
      {/* Header / Navigation */}
      <header className="sticky top-0 z-40 backdrop-blur-xl" style={{ borderBottom: '1px solid rgba(169, 201, 232, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.95)' }}>
        <div className="max-w-6xl mx-auto px-4 h-12 flex items-center justify-between gap-4">
          <Logo />
          <nav className="hidden md:flex items-center gap-6 text-sm" style={{ color: 'rgb(100, 130, 160)' }}>
            <a href="#why-us" className="transition-colors hover:opacity-80" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.nav.whyUs')}</a>
            <a href="#stats" className="transition-colors hover:opacity-80" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.nav.stats')}</a>
            <a href="#how-it-works" className="transition-colors hover:opacity-80" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.nav.howItWorks')}</a>
            <a href="#faq" className="transition-colors hover:opacity-80" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.nav.faq')}</a>
          </nav>
          <div className="flex items-center gap-2">
            <LanguageSwitch />
            <Button 
              variant="ghost" 
              size="sm" 
              className="text-xs md:text-sm" 
              style={{ color: 'rgb(100, 130, 160)' }}
              onClick={() => navigate('/login')}
            >
              {t('landing.login')}
            </Button>
            {/* <Button 
              size="sm" 
              className="text-xs md:text-sm" 
              style={{ backgroundColor: 'rgb(169, 201, 232)', color: '#FFFFFF' }}
              onClick={() => navigate('/register')}
            >
              {t('landing.getFreeCheck')}
            </Button> */}
          </div>
        </div>
      </header>

      {/* Main content */}
      <main className="flex-1">
        <section className="max-w-6xl mx-auto px-4 py-10 md:py-16 space-y-8">
          {/* Hero heading */}
          <div>
            <div className="inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-medium tracking-wide mb-4" style={{ border: '1px solid rgba(169, 201, 232, 0.4)', backgroundColor: 'rgba(169, 201, 232, 0.15)', color: '#1B211A' }}>
              <span className="w-1.5 h-1.5 rounded-full animate-pulse" style={{ backgroundColor: 'rgb(169, 201, 232)' }} />
              {t('landing.hero.badge')}
            </div>
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tight mb-4" style={{ color: '#1B211A' }}>
              {language === 'de' ? (
                <>Gerechtigkeit, die sich rechnet!</>
              ) : (
                <>Are you entitled to <span style={{ color: 'rgb(169, 201, 232)' }}>refund</span>?</>
              )}
            </h1>
          </div>

          {/* Description + steps row */}
          <div className="grid gap-8 lg:grid-cols-[minmax(0,1.1fr)_minmax(0,0.9fr)] items-start">
            <div>
              <div
                className="text-xs md:text-sm max-w-2xl mb-6 leading-relaxed space-y-3"
                style={{ color: 'rgb(120, 145, 170)' }}
              >
                <p className="text-sm font-semibold" style={{ color: '#1B211A' }}>
                  {t('landing.hero.reasonTitle')}
                </p>
                <p>{t('landing.hero.reason.p1')}</p>
                <p>{t('landing.hero.reason.p2')}</p>
                <p>{t('landing.hero.reason.p3')}</p>
              </div>
              <div className="flex flex-wrap items-center gap-3 mb-6">
                <Button 
                  size="lg" 
                  className="text-lg font-bold rounded-full px-10 py-7 tracking-wide transition-all duration-300 hover:scale-[1.04] active:scale-[0.98]" 
                  style={{ 
                    background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 35%, #60a5fa 100%)', 
                    color: '#FFFFFF',
                    border: 'none',
                    boxShadow: '0 8px 24px rgba(37, 99, 235, 0.5), 0 2px 8px rgba(0, 0, 0, 0.08)',
                    textShadow: '0 1px 2px rgba(0, 0, 0, 0.1)',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.boxShadow = '0 12px 32px rgba(37, 99, 235, 0.55), 0 4px 12px rgba(0, 0, 0, 0.1)';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.boxShadow = '0 8px 24px rgba(37, 99, 235, 0.5), 0 2px 8px rgba(0, 0, 0, 0.08)';
                  }}
                  onClick={() => navigate('/register')}
                >
                  <span className="flex items-center gap-3">
                    {t('landing.hero.cta')}
                    <ArrowRight className="w-6 h-6" strokeWidth={2.5} />
                  </span>
                </Button>
                <p className="text-[11px]" style={{ color: 'rgb(100, 130, 160)' }}>
                  {t('landing.hero.disclaimer')}
                </p>
              </div>
              <div className="flex flex-wrap gap-4 text-xs" style={{ color: 'rgb(100, 130, 160)' }}>
                <div className="flex items-center gap-2">
                  <Shield className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  <span>{t('landing.hero.hosted')}</span>
                </div>
                <div className="flex items-center gap-2">
                  <CheckCircle2 className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  <span>{t('landing.hero.caseLaw')}</span>
                </div>
              </div>
            </div>

            <div
                className="rounded-2xl p-6 md:p-7 space-y-5"
                style={{ backgroundColor: 'rgba(255, 255, 255, 0.7)', border: '1px solid rgba(169, 201, 232, 0.35)' }}
              >
                <h3 className="text-lg md:text-xl font-semibold tracking-tight" style={{ color: '#1B211A' }}>
                  {t('landing.hero.steps.title')}
                </h3>
                <ol className="space-y-4 text-sm md:text-base" style={{ color: '#1B211A' }}>
                  <li className="flex items-start gap-3">
                    <span className="text-base md:text-lg font-semibold">1.</span>
                    <span>{t('landing.hero.steps.step1')}</span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-base md:text-lg font-semibold">2.</span>
                    <span>
                      {t('landing.hero.steps.step2')}
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-base md:text-lg font-semibold">3.</span>
                    <div className="space-y-2">
                      <div>
                        {t('landing.hero.steps.step3a')}
                      </div>
                      <ul className="space-y-1 text-sm" style={{ color: 'rgb(100, 130, 160)' }}>
                        <li className="flex items-start gap-2">
                          <span>✓</span>
                          <span>{t('landing.hero.steps.step3b1')}</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span>✓</span>
                          <span>{t('landing.hero.steps.step3b2')}</span>
                        </li>
                        <li className="flex items-start gap-2">
                          <span>✓</span>
                          <span>{t('landing.hero.steps.step3b3')}</span>
                        </li>
                      </ul>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <span className="text-base md:text-lg font-semibold">4.</span>
                    <span>
                      {t('landing.hero.steps.step4')}
                    </span>
                  </li>
                </ol>
            </div>
          </div>
        </section>

        {/* Statistics section */}
        <section id="stats" className="max-w-6xl mx-auto px-4 py-10 md:py-14" style={{ borderTop: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <KPIBoard />
        </section>
        
        {/* Why choose us */}
        <section id="why-us" className="max-w-6xl mx-auto px-4 py-10 md:py-14" style={{ borderTop: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 mb-8">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold tracking-tight mb-2" style={{ color: '#1B211A' }}>{t('landing.whyUs.title')}</h2>
            
            </div>
          </div>
          <div className="grid gap-5 md:grid-cols-3">
            <Card className="group rounded-2xl overflow-hidden transition-transform duration-200 hover:-translate-y-1 cursor-pointer" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
              <CardContent className="pt-6 pb-6 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="p-2.5 rounded-xl" style={{ backgroundColor: 'rgba(169, 201, 232, 0.2)', border: '1px solid rgba(169, 201, 232, 0.4)' }}>
                    <FileSearch className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  </div>
                  <h3 className="text-sm font-semibold" style={{ color: '#1B211A' }}>{t('landing.whyUs.analysis.title')}</h3>
                </div>
                <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
                  {t('landing.whyUs.analysis.description')}
                </p>
              </CardContent>
            </Card>

            <Card className="group rounded-2xl overflow-hidden transition-transform duration-200 hover:-translate-y-1 cursor-pointer" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
              <CardContent className="pt-6 pb-6 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="p-2.5 rounded-xl" style={{ backgroundColor: 'rgba(169, 201, 232, 0.2)', border: '1px solid rgba(169, 201, 232, 0.4)' }}>
                    <Scale className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  </div>
                  <h3 className="text-sm font-semibold" style={{ color: '#1B211A' }}>{t('landing.whyUs.estimation.title')}</h3>
                </div>
                <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
                  {t('landing.whyUs.estimation.description')}
                </p>
              </CardContent>
            </Card>

            <Card className="group rounded-2xl overflow-hidden transition-transform duration-200 hover:-translate-y-1 cursor-pointer" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
              <CardContent className="pt-6 pb-6 space-y-3">
                <div className="flex items-center gap-3">
                  <div className="p-2.5 rounded-xl" style={{ backgroundColor: 'rgba(169, 201, 232, 0.2)', border: '1px solid rgba(169, 201, 232, 0.4)' }}>
                    <Shield className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  </div>
                  <h3 className="text-sm font-semibold" style={{ color: '#1B211A' }}>{t('landing.whyUs.gdpr.title')}</h3>
                </div>
                <p className="text-xs leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
                  {t('landing.whyUs.gdpr.description')}
                </p>
              </CardContent>
            </Card>
          </div>
        </section>

        {/* How we proceed - zigzag roadmap */}
        <section id="how-it-works" className="max-w-6xl mx-auto px-4 py-10 md:py-14" style={{ borderTop: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <div className="grid gap-10 lg:grid-cols-[minmax(0,1fr)_minmax(0,1fr)] lg:gap-12 items-stretch">
            {/* Left: title + intro in a card for visual weight */}
            <Card className="rounded-2xl overflow-hidden flex flex-col border-0 shadow-none" style={{ backgroundColor: 'rgba(255, 255, 255, 0.8)' }}>
              <CardContent className="pt-6 pb-6 md:pt-8 md:pb-8 space-y-5 flex-1">
                <h2 className="text-2xl md:text-3xl font-semibold tracking-tight" style={{ color: 'rgb(169, 201, 232)' }}>
                  {t('landing.howItWorks.title')}
                </h2>
                {/* Tagline highlights - fill space and add structure */}
                <div className="flex flex-wrap gap-3 py-2">
                  <div className="flex items-center gap-2 rounded-xl px-3 py-2" style={{ backgroundColor: 'rgba(169, 201, 232, 0.12)', border: '1px solid rgba(169, 201, 232, 0.25)' }}>
                    <Gift className="w-4 h-4 shrink-0" style={{ color: 'rgb(169, 201, 232)' }} />
                    <span className="text-xs font-medium" style={{ color: '#1B211A' }}>{t('landing.howItWorks.pillFree')}</span>
                  </div>
                  <div className="flex items-center gap-2 rounded-xl px-3 py-2" style={{ backgroundColor: 'rgba(169, 201, 232, 0.12)', border: '1px solid rgba(169, 201, 232, 0.25)' }}>
                    <CheckCircle2 className="w-4 h-4 shrink-0" style={{ color: 'rgb(169, 201, 232)' }} />
                    <span className="text-xs font-medium" style={{ color: '#1B211A' }}>{t('landing.howItWorks.pillNonBinding')}</span>
                  </div>
                  <div className="flex items-center gap-2 rounded-xl px-3 py-2" style={{ backgroundColor: 'rgba(169, 201, 232, 0.12)', border: '1px solid rgba(169, 201, 232, 0.25)' }}>
                    <Lock className="w-4 h-4 shrink-0" style={{ color: 'rgb(169, 201, 232)' }} />
                    <span className="text-xs font-medium" style={{ color: '#1B211A' }}>{t('landing.howItWorks.pillSecure')}</span>
                  </div>
                </div>
                <div className="text-xs md:text-sm leading-relaxed space-y-3" style={{ color: 'rgb(100, 130, 160)' }}>
                  <p>{t('landing.howItWorks.left.p1')}</p>
                  <p>{t('landing.howItWorks.left.p2')}</p>
                  <p>{t('landing.howItWorks.left.p3')}</p>
                  <p>{t('landing.howItWorks.left.p4')}</p>
                  <p>{t('landing.howItWorks.left.p5')}</p>
                  <p>{t('landing.howItWorks.left.p6')}</p>
                </div>
              </CardContent>
            </Card>

            {/* Right: zigzag roadmap */}
            <div className="space-y-0">
              <div className="relative flex flex-col gap-0.5 md:gap-1">
                {/* Central vertical line */}
                <div
                  className="absolute left-1/2 top-0 bottom-0 w-px -translate-x-1/2 hidden md:block pointer-events-none"
                  style={{ backgroundColor: 'rgba(169, 201, 232, 0.4)' }}
                  aria-hidden
                />
                {[1, 2, 3, 4, 5].map((num, index) => (
                  <div
                    key={num}
                    className={`relative flex ${index % 2 === 0 ? 'md:justify-start' : 'md:justify-end'}`}
                  >
                    <div
                      className="w-full md:max-w-[calc(50%-0.75rem)] rounded-2xl p-3 transition-colors shadow-sm"
                      style={{ backgroundColor: 'rgba(255, 255, 255, 0.9)', border: '1px solid rgba(169, 201, 232, 0.35)' }}
                    >
                      <h4 className="text-sm font-semibold mb-1" style={{ color: 'rgb(169, 201, 232)' }}>
                        {t(`landing.howItWorks.detail${num}.title`)}
                      </h4>
                      <p className="text-xs leading-snug" style={{ color: 'rgb(100, 130, 160)' }}>
                        {t(`landing.howItWorks.detail${num}.body`)}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <p className="text-[11px] mt-4 leading-relaxed" style={{ color: 'rgb(100, 130, 160)' }}>
                {t('landing.howItWorks.footnote')}
              </p>
            </div>
          </div>
        </section>

        {/* FAQ & GDPR note */}
        <section id="faq" className="max-w-6xl mx-auto px-4 py-10 md:py-14" style={{ borderTop: '1px solid rgba(169, 201, 232, 0.3)' }}>
          <div className="grid gap-8 lg:grid-cols-[minmax(0,1.3fr)_minmax(0,1fr)] items-start">
            <div>
              <h2 className="text-2xl md:text-3xl font-semibold tracking-tight mb-2" style={{ color: '#1B211A' }}>{t('faq.title')}</h2>
              <p className="text-sm mb-4 max-w-xl" style={{ color: 'rgb(100, 130, 160)' }}>
                {t('faq.subtitle')}
              </p>
              <Accordion type="single" collapsible className="w-full space-y-2">
                {faqs.map((faq, index) => (
                  <AccordionItem 
                    key={`faq-${index}`} 
                    value={`item-${index + 1}`}
                    className="rounded-lg px-4 transition-colors"
                    style={{ border: '1px solid rgba(169, 201, 232, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.6)' }}
                  >
                    <AccordionTrigger className="text-sm hover:no-underline py-4" style={{ color: '#1B211A' }}>
                      {faq.q}
                    </AccordionTrigger>
                    <AccordionContent className="text-xs leading-relaxed pb-4 pt-0" style={{ color: 'rgb(100, 130, 160)' }}>
                      {faq.a}
                    </AccordionContent>
                  </AccordionItem>
                ))}
              </Accordion>
            </div>

            <Card className="rounded-2xl" style={{ backgroundColor: 'rgba(255, 255, 255, 0.6)', border: '1px solid rgba(169, 201, 232, 0.3)' }}>
              <CardContent className="pt-6 pb-6 space-y-4">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-2.5 rounded-xl" style={{ backgroundColor: 'rgba(169, 201, 232, 0.2)', border: '1px solid rgba(169, 201, 232, 0.4)' }}>
                    <Shield className="w-4 h-4" style={{ color: 'rgb(169, 201, 232)' }} />
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold" style={{ color: '#1B211A' }}>{t('landing.gdpr.title')}</h3>
                    <p className="text-[11px]" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.gdpr.subtitle')}</p>
                  </div>
                </div>
               
                <ul className="text-xs space-y-1" style={{ color: 'rgb(100, 130, 160)' }}>
                  <li>• {t('landing.gdpr.bullet1')}</li>
                  <li>• {t('landing.gdpr.bullet2')}</li>
                  <li>• {t('landing.gdpr.bullet3')}</li>
                  <li>• {t('landing.gdpr.bullet4')}</li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer id="gdpr" style={{ borderTop: '1px solid rgba(169, 201, 232, 0.3)', backgroundColor: 'rgba(255, 255, 255, 0.98)' }}>
        <div className="max-w-6xl mx-auto px-4 py-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 text-[11px]" style={{ color: 'rgb(100, 130, 160)' }}>
          <p>
            {t('landing.footer.disclaimer').replace('{year}', new Date().getFullYear())}
          </p>
          <div className="flex flex-wrap gap-4 md:justify-end">
            <a href="https://www.kolrus.com/datenschutz/" className="hover:opacity-80 transition-opacity" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.footer.gdpr')}</a>
            <a href="https://www.kolrus.com/impressum/" className="hover:opacity-80 transition-opacity" style={{ color: 'rgb(100, 130, 160)' }}>{t('landing.footer.impressum')}</a>
            <button
              type="button"
              onClick={openCookieSettings}
              className="hover:opacity-80 transition-opacity bg-transparent border-0 cursor-pointer p-0 font-inherit text-[11px]"
              style={{ color: 'rgb(100, 130, 160)' }}
            >
              {t('cookieBanner.reopenLink')}
            </button>
          </div>
        </div>
      </footer>
    </div>
  );
};

const Landing = CreditRefundLandingPage;
export default Landing;
